const A4_WIDTH_PX = (210 / 25.4) * 96;
const CARD_SIDE_INSET_PX = 14 * 2;
// Must match certificate v4 photo band (certificate4 mg-photo-wrap) and CertificateMessageLayout.
const PHOTO_HEIGHT_PX = 410;

export const CERTIFICATE_PHOTO_ASPECT = (A4_WIDTH_PX - CARD_SIDE_INSET_PX) / PHOTO_HEIGHT_PX;

export const CERTIFICATE_PHOTO_OUTPUT_WIDTH = 1920;
export const CERTIFICATE_PHOTO_OUTPUT_HEIGHT = Math.round(
  CERTIFICATE_PHOTO_OUTPUT_WIDTH / CERTIFICATE_PHOTO_ASPECT
);
